import React, { useEffect, useState } from 'react'
import { CloseOutlined } from '@ant-design/icons'
import { Button, Card, notification, Row, Col, Input, Select, Space } from 'antd'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { Route } from 'react-router-dom'

import { addVLPCustomCard, initializeVLPCustomCard, resetVLPCustomCardActionStatus } from '~actions'
import { ImageUploader, ResultModal } from '~components'
import { getCurrentUser } from '~context'
import { MultiSelectDropdown, PageLayout, Spinner } from '~stories'

import styles from './NewVLPCustomCard.module.css'

const PAGE_TITLE = 'New VLP Card'
const NOTIFICATION_MESSAGES = {
  UNAUTHORIZED: 'You are not authorized to perform this action.'
}

const NewVLPCustomCard = ({
  addVLPCustomCard,
  initializeVLPCustomCard,
  msgFlagsList,
  newVlpCustomCardId,
  resetVLPCustomCardActionStatus,
  allVenues,
  updateMessage,
  updateStatus
}) => {
  const [isDataLoaded, setIsDataLoaded] = useState()
  const { access_token: accessToken, userDetails: { isContentEditor } } = getCurrentUser()
  const [vlpCustomCard, setVlpCustomCard] = useState({
    id: 'VLP-CARD-' + Date.now(),
    venue_id: null,
    default_image: null,
    flags: [],
    sub_title: '',
    name: '',
    type: 'custom_card',
    ctas: []
  })
  const [selectedFlags, setSelectedFlags] = useState([])

  useEffect(() => {
    initializeVLPCustomCard(accessToken)
    setIsDataLoaded(false)
  }, [accessToken, initializeVLPCustomCard])

  const handleSubmit = () => {
    if (!isContentEditor) {
      notification.error({ message: NOTIFICATION_MESSAGES.UNAUTHORIZED })
      return
    }

    setIsDataLoaded(false)
    addVLPCustomCard({
      ...vlpCustomCard
    }, accessToken)
  }

  const handleIconChange = (imgObj) => {
    const clonedVlpCard = { ...vlpCustomCard }
    clonedVlpCard.default_image = { ...clonedVlpCard.default_image, ...imgObj }
    setVlpCustomCard(clonedVlpCard)
  }

  const handleImageUrlUpdate = (imageUrl) => {
    const clonedVlpCard = { ...vlpCustomCard }
    clonedVlpCard.default_image = { ...clonedVlpCard.default_image, url: imageUrl }
    setVlpCustomCard(clonedVlpCard)
  }

  const handleFlagsUpdate = (selectedItem) => {
    setSelectedFlags(selectedItem)
    const selectedFlags = msgFlagsList.filter(flag => [selectedItem].includes(flag.title))
    setVlpCustomCard({ ...vlpCustomCard, flags: selectedFlags })
  }

  const handleDeleteCta = (index) => {
    const ctas = [...(vlpCustomCard.ctas || [])]
    ctas.splice(index, 1)
    setVlpCustomCard({ ...vlpCustomCard, ctas })
  }

  const handleCtaChange = (index, field, value) => {
    const ctas = [...(vlpCustomCard.ctas || [])]
    ctas[index] = { ...ctas[index], [field]: value }
    setVlpCustomCard({ ...vlpCustomCard, ctas })
  }

  const handleAddCta = () => {
    if ((vlpCustomCard.ctas || []).length < 2) {
      setVlpCustomCard({
        ...vlpCustomCard,
        ctas: [...(vlpCustomCard.ctas || []), { label: '', url: '' }]
      })
    }
  }

  const handleModalClose = () => {
    resetVLPCustomCardActionStatus()
  }

  const editVlp = (
    <Route key="editVlp" render={({ history }) => (

      <Button
        onClick={() => {
          newVlpCustomCardId && history.push(`/venues/venue-landing-cards/${newVlpCustomCardId}/edit`)
          window.location.reload()
        }}
        type="primary"
      >
        Keep Editing
      </Button>
    )} />
  )

  const goToListVlpCardsButton = (
    <Route key="listVlpCards" render={({ history }) => (
      <Button
        onClick={() => {
          resetVLPCustomCardActionStatus()
          history.push('/venues/venue-landing-cards')
          window.location.reload()
        }}
        type="primary"
      >
        Go to VLP Cards List
      </Button>
    )} />
  )

  const addVlpCustomCardButton = <Button onClick={handleSubmit} type='primary'>
    Add
  </Button>

  console.log('allVenues', vlpCustomCard, allVenues)
  return (
    <PageLayout extra={[addVlpCustomCardButton]} title={PAGE_TITLE}>
      <div className={styles['new-vlp-custom-card-container']}>
        {isDataLoaded === false && <Spinner />}
        <Card style={{ width: '100%' }}>
          <Row gutter={16}>
            <Col span={12}>
              <Space direction="vertical" style={{ width: '100%' }}>
                <label htmlFor="uniqueNameInput" style={{ marginBottom: 8, marginTop: 16, display: 'block' }}>Id (unique, not editable):</label>
                <Input
                  disabled
                  id="uniqueNameInput"
                  value={vlpCustomCard?.id}
                />
                <label htmlFor="titleInput" style={{ marginBottom: 8, marginTop: 16, display: 'block' }}>Name:</label>
                <Input
                  id="titleInput"
                  onChange={e => setVlpCustomCard({ ...vlpCustomCard, name: e.target.value })}
                  placeholder="Enter name"
                  value={vlpCustomCard.name}
                />
              </Space>
            </Col>
            <Col span={12}>
              <Space direction="vertical" style={{ width: '100%' }}>

                <label htmlFor="venueSelect" style={{ marginBottom: 8, marginTop: 16, display: 'block' }}>Venue:</label>
                <Select
                  id="venueSelect"
                  onChange={value => setVlpCustomCard({ ...vlpCustomCard, venue_id: value })}
                  placeholder="Select a venue"
                  style={{ width: '100%' }}
                  value={vlpCustomCard.venue_id}
                >
                  {Array.isArray(allVenues) && allVenues.map(venue => (
                    <Select.Option key={venue.value} value={venue.value}>
                      {venue.label}
                    </Select.Option>
                  ))}
                </Select>
                <label htmlFor="subtitleInput" style={{ marginBottom: 8, marginTop: 16, display: 'block' }}>Subtitle:</label>
                <Input
                  id="subtitleInput"
                  onChange={e => setVlpCustomCard({ ...vlpCustomCard, sub_title: e.target.value })}
                  placeholder="Enter subtitle"
                  value={vlpCustomCard.sub_title}
                />
              </Space>
            </Col>
          </Row>
          <Row gutter={16}>
            <Col span={12}>
              <label htmlFor="defaultImageUploader" style={{ marginBottom: 8, marginTop: 16, display: 'block' }}>Flags&nbsp;&nbsp;(Select one item from the dropdown):</label>
              <MultiSelectDropdown
                allowClear={true}
                displayField="title"
                dropdownOptions={msgFlagsList || []}
                handleChange={handleFlagsUpdate}
                selectedItems={selectedFlags || []}
                valueField="title"
              />
            </Col>
          </Row>
          <Row gutter={16}>
            <Col span={16}>
              <div style={{ marginTop: 16 }}>
                <label style={{ marginBottom: 8, marginRight: 12 }}>CTAs (max 2):</label>
                <Button disabled={(vlpCustomCard.ctas || []).length >= 2} onClick={handleAddCta} style={{ marginBottom: 8 }}
                  type="primary">
                    Add CTA
                </Button>
                {(vlpCustomCard.ctas || []).map((cta, idx) => (
                  <div key={idx} style={{ marginBottom: 12, display: 'flex', gap: 8, alignItems: 'center' }}>
                    <Input
                      onChange={e => handleCtaChange(idx, 'label', e.target.value)}
                      placeholder="CTA Label"
                      style={{ width: '40%' }}
                      value={cta.label}
                    />
                    <Input
                      onChange={e => handleCtaChange(idx, 'url', e.target.value)}
                      placeholder="CTA URL"
                      style={{ width: '50%' }}
                      value={cta.url}
                    />
                    <Button
                      aria-label="Delete CTA"
                      icon={<CloseOutlined />}
                      onClick={() => handleDeleteCta(idx)}
                      onMouseEnter={e => { e.currentTarget.style.background = '#d9363e' }}
                      onMouseLeave={e => { e.currentTarget.style.background = '#ff4d4f' }}
                      style={{
                        background: '#ff4d4f',
                        color: '#fff',
                        borderRadius: '50%',
                        width: 32,
                        height: 32,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        boxShadow: '0 2px 8px rgba(255,77,79,0.15)',
                        transition: 'background 0.3s',
                        fontSize: 16,
                        border: 'none',
                        cursor: 'pointer'
                      }}
                      type="text"
                    />
                  </div>
                ))}
              </div>
            </Col>
          </Row>
          <Row gutter={16}>
            <Col span={12}>
              <label htmlFor="defaultImageUploader" style={{ marginBottom: 8, marginTop: 16, display: 'block' }}>Default Image:</label>
              <ImageUploader
                alt={vlpCustomCard?.default_image?.alt}
                handleIconChange={imageObj => handleIconChange(imageObj)}
                handleUpload={imageUrl => handleImageUrlUpdate(imageUrl)}
                logoUrl={vlpCustomCard?.default_image?.url}
              />
            </Col>
          </Row>
        </Card>
      </div>
      {
        updateStatus &&
        <ResultModal
          actions={[
            editVlp,
            goToListVlpCardsButton
          ]}
          handleCancel={handleModalClose}
          status="success"
          title={updateMessage}
        />
      }
    </PageLayout>
  )
}

const mapStateToProps = ({ vlpCards }) => {
  console.log('vlpCards', vlpCards)
  return ({
    newVlpCustomCardId: vlpCards?.newVlpCustomCardId,
    updateMessage: vlpCards?.message,
    allVenues: vlpCards?.venues,
    msgFlagsList: vlpCards?.allFlags,
    updateStatus: vlpCards?.success
  })
}

const mapDispatchToProps = {
  addVLPCustomCard,
  initializeVLPCustomCard,
  resetVLPCustomCardActionStatus
}

NewVLPCustomCard.propTypes = {
  addVLPCustomCard: PropTypes.func,
  allVenues: PropTypes.array,
  initializeVLPCustomCard: PropTypes.func,
  msgFlagsList: PropTypes.array,
  newVlpCustomCardId: PropTypes.string,
  resetVLPCustomCardActionStatus: PropTypes.func,
  updateMessage: PropTypes.string,
  updateStatus: PropTypes.bool
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(NewVLPCustomCard)
